import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
    SpecificPerformanceReport
} from "../../Repository/Api";
import { DownloadPerformanceIndex } from "../Common/DownloadPerformanceIndex";
import SubmittedPerformanceIndex from "../Common/SubmittedPerformanceIndex";
import { errorMsg } from "../Toastify";
const DirectorPerformanceSpecificView = () => {
    const { first_name, department, access_token } = useSelector((state) => state?.auth?.auth);
    const token = access_token
    const navigate = useNavigate();
    const { id } = useParams()
    const state = useLocation()
    // const data = state && state?.data
    
    // 
    const [count, setCount] = useState({});

    useEffect(() => {
        getCount();
    },[]);

    const [active, setActive] = useState(0);
    const links = ["Part - A", "Part - B", "Part - C", "Part - D"];
    const showSelected = (index) => {
        setActive(index);
    };
    const getCount = async () => {
        const response = await SpecificPerformanceReport(id, token);
        if (response && response.statusCode === 200) {
            setCount(response?.data);
        } else {
            errorMsg(response.message);
        }
    };

    return (
        <>
            <div className="">
                <section className="top-content-container">
                    <div className="my-4">
                        <div className="row">
                            <div className="col-lg-6">
                                <h6 className="headertext">{first_name}</h6>
                                <h6 className="subheadertext">{department}</h6>
                            </div>
                        </div>
                    </div>
                </section>
                <section>
                    <div className="row">
                        <div className="">
                            <div className="graphbox">
                                <form>
                                    <div className="row">
                                        <div className="col-lg-12 my-auto">
                                            <h6 className="labeltitle">
                                                <span
                                                    className="arrowicon"
                                                    onClick={() => {
                                                        navigate(-1);
                                                    }}
                                                >
                                                    ← &nbsp;
                                                </span>
                                                Performance Score Board Fixed
                                            </h6>
                                        </div>
                                    </div>
                                    <div className="mt-5">
                                        <ul className="searchtopflex">
                                            {links.map((link, index) => {
                                                return (
                                                    <li
                                                        onClick={() => showSelected(index)}
                                                        key={link}
                                                        className={
                                                            active === index
                                                                ? "agenttextactive"
                                                                : "agenttextinactive"
                                                        }
                                                    >
                                                        {link}
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                    <SubmittedPerformanceIndex active={active} count={count} />
                                    <div className="text-center my-5">
                                        <button type="submit" className="requestbtn" onClick={(e) => DownloadPerformanceIndex(count, e)}>Download Report</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default DirectorPerformanceSpecificView;
